export default "__VITE_ASSET__B$T3xpJ9__"